export default __webpack_public_path__ + "static/media/icon_BUSD.171a77d8.png";